import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

    model: any[] = [];
    private manualUrl = '/assets/xrack_manual.pdf';
    constructor(public layoutService: LayoutService) { }

    ngOnInit() {
        this.model = [
            {
                items: [
                    { label: 'Inicio', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
                    { label: 'Histórico de eventos', icon: 'pi pi-fw pi-book', routerLink: ['/historico'] }
                ]
            }
        ];
    }


    public downloadHelp(): void {
        let link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', this.manualUrl);
        link.setAttribute('download', 'manual.pdf');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
